import { render, staticRenderFns } from "./ProjectUserList.vue?vue&type=template&id=d2f19ed2&scoped=true&"
import script from "./ProjectUserList.vue?vue&type=script&lang=js&"
export * from "./ProjectUserList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUserList.vue?vue&type=style&index=0&id=d2f19ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f19ed2",
  null
  
)

export default component.exports